import { SxProps } from '@mui/system'

const tableRowStyle: { [name: string]: SxProps } = {
    root: {
        width: '100%',
    },
    disabled: {
        opacity: 0.4,
    },
    header: {
        bgcolor: 'default.main',
    },
}

export default tableRowStyle
